import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import Logo from '../../../assets/images/logo-login.png';
import { Container } from './styles';

import Input from '../../../components/Input';
import Loading from '../../../components/Loading';

export default class Login extends Component {
  state = {
    alert: {},
    email: '',
    password: '',
    showAlert: false,
    loading: false,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const { email, password } = this.state;

      const res = await api.post('admin_token', {
        auth: {
          email,
          password,
        },
      });

      localStorage.setItem('token_admin', res.data.jwt);
      this.props.history.push('/admin/dashboard');
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      email,
      loading,
      password,
      showAlert,
    } = this.state;

    return (
      <Container>
        {loading && <Loading />}
        <div>
          <div className="row">
            <div className="col-12">
              <img
                src={Logo}
                alt="Divulgaí"
                className="logo"
                height={70}
                style={{
                  maxHeight: '70px',
                  marginBottom: '20px',
                }}
              />
              <h1>Admin</h1>
              <form onSubmit={this.handleSubmit}>
                <Input
                  name="email"
                  value={email}
                  type="email"
                  placeholder="Email"
                  onChange={this.handleChange}
                />
                <Input
                  name="password"
                  value={password}
                  type="password"
                  placeholder="Senha"
                  onChange={this.handleChange}
                />
                <input
                  type="submit"
                  style={{ width: '100%' }}
                  className="btn btn-primary"
                  value="Entrar"
                />
                <p className="recoverPassword">
                  <Link to="/admin/reset_password">Recuperar senha</Link>
                </p>
              </form>
            </div>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Login/index.js